import Lang from "@/lang";

export const AWS_SERVICE_NAME = process.env.AWS_SERVICE_NAME;

type ApiRoute = {
  PATH: string;
};

export const API_ROUTES: Record<string, ApiRoute> = {
  AGENCIES: {
    PATH: "/agencies",
  },

  TENANTS: {
    PATH: "/tenants",
  },

  USERS: {
    PATH: "/users",
  },

  USER_SETTINGS: {
    PATH: "/user-settings",
  },

  RESET_PASSWORD: {
    PATH: "/reset-password",
  },

  REPORTS: {
    PATH: "/reports",
  },
  REPORT: {
    PATH: "/report",
  },

  CATALOG: {
    PATH: "/catalog",
  },

  PROJECT_CATALOG: {
    PATH: "/projects/catalog",
  },

  SUMMARY: {
    PATH: "/summary",
  },

  TEMPLATES: {
    PATH: "/templates",
  },

  PLAN_TEMPLATES: {
    PATH: "/plan_templates",
  },

  PROJECTS: {
    PATH: "/projects",
  },

  ADVERTISERS: {
    PATH: "/advertisers",
  },

  ADVERTISER_CONSOLE: {
    PATH: "/advertiser_console",
  },

  UPDATE_PLAN: {
    PATH: "/update_plan",
  },

  SCENARIOS: {
    PATH: "/scenarios",
  },

  PLANS: {
    PATH: "/plans",
  },

  AUDIENCE_CALCULATE: {
    PATH: "/audience_calculate",
  },

  GEO_EXPORT: {
    PATH: "/geo_export",
  },

  GEO_VALIDATE: {
    PATH: "/geo_validate",
  },

  SCENARIO_COMPARISONS: {
    PATH: "/scenario_comparisons",
  },

  TRADITIONAL_CHANNEL_METRICS_CALCULATE: {
    PATH: "/traditional_channel_metrics_calculate",
  },
};

export const apiErrorCodes: { code: number; message: string }[] = [
  {
    code: 1003,
    message: Lang.userAlreadyExists,
  },
  {
    code: 1002,
    message: Lang.emptyTenantsList,
  },
];

export const apiErrorStatuses: { status: number; message: string }[] = [{ status: 404, message: Lang.notFound }];

export const requestTokens = {
  apiGetSummary: "api_get_summary",
  apiGetChartData: "api_get_chart_data",
  apiCatalogs: "api_catalogs",
  apiProjectsCatalogs: "api_projects_catalogs",
  apiGetUserSettings: "api_get_user_settings",
  apiSetDefaultUserSettings: "api_set_default_user_settings",
  apiGetTableData: "api_get_table_data",
  apiAddNewPage: "api_add_new_page",
  apiUpdatePage: "api_update_page",
  apiDeleteUserSettings: "api_delete_user_settings",
  apiServiceGeneralRequest: "api_service_general_request",
  apiServiceLoadReport: "api_service_load_report",
  apiCreateTenant: "api_create_tenant",
  apiEditTenant: "api_edit_tenant",
  apiGetTenants: "api_get_tenants",
  apiDisableAccount: "api_disable_account",
  apiGetAgencies: "api_get_agencies",
  apiGetTenantById: "api_get_tenant_by_id",
  apiGetUsers: "api_get_users",
  apiGetTenantsFromUserManagement: "api_get_tenants_from_user_management",
  apiEnableUser: "api_enable_user",
  apiDisableUser: "api_disable_user",
  apiSaveUser: "api_save_user",
  apiUpdateUser: "api_update_user",
  apiDelTemplate: "api_del_template",
  apiPublishTemplate: "api_publish_template",
  apiCreateTemplate: "api_create_template",
  apiGetComparisons: "api_get_comparisons",
  apiCreatePlanTemplate: "api_create_plan_template",
  apiUpdateTemplate: "api_update_template",
  apiGetTemplates: "api_get_templates",
  apiResetPassword: "api_reset_password",
  apiGetProjects: "api_get_projects",
  apiGetProjectByID: "api_get_project_by_id",
  apiGetProjectLayout: "api_get_project_layout",
  apiGetComparisonCandidates: "api_get_comparison_candidates",
  apiUpdateProjectOutput: "api_update_project_output",
  apiCreateProjectLayout: "api_create_project_layout",
  apiPostProjectGenerate: "api_post_project_generate",
  apiGetProjectGenerateJobStatus: "api_get_project_generate_job_status",
  apiCreateProject: "api_create_projects",
  apiAudienceCalculate: "api_audience_calculate",
  apiAudienceExport: "api_audience_export",
  apiUpdateProject: "api_update_projects",
  apiScenarioApprove: "api_scenario_approve",
  apiScenarioDisapprove: "api_scenario_disapprove",
  apiPlansApprove: "api_plan_approve",
  apiPlansDisapprove: "api_plan_disapprove",
  apiGetAdvertisers: "api_get_advertisers",
  apiGetAdvertiser: "api_get_advertiser",
  apiGetAdvertisersList: "api_get_advertisers_list",
  apiGetAdvertiserDetail: "api_get_advertiser_detail",
  apiGetAdvertisersCatalog: "api_get_advertisers_catalog",
  apiCreateAdvertiser: "api_create_advertiser",
  apiUpdateAdvertiser: "api_update_advertiser",
  apiTraditionalChannelMetrics: "api_traditional_channel_metrics",
};

export const requestStatusesDictionary: { [key: string]: string } = {
  sent: "sent",
  answered: "answered",
  error: "error",
};

export type RequestStatusDictionary = "sent" | "answered" | "error";
export type RequestMethods = "get" | "post" | "patch" | "put" | "del";
